// utils/toast.js
import { useToast } from 'vue-toastification';

// Create a toast instance that can be used in services
let toastInstance = null;

export const initializeToast = (app) => {
  // Get the toast instance from the app
  toastInstance = app.config.globalProperties.$toast;
};

export const showToast = (message, options = {}) => {
  if (toastInstance) {
    toastInstance(message, options);
  } else if (window.toast) {
    // Fallback to window.toast if available
    window.toast(message, options);
  } else {
    // Fallback to console if no toast is available
    console.log('Toast:', message, options);
  }
};

export const showSuccessToast = (message, options = {}) => {
  showToast(message, { type: 'success', ...options });
};

export const showErrorToast = (message, options = {}) => {
  showToast(message, { type: 'error', ...options });
};

export const showWarningToast = (message, options = {}) => {
  showToast(message, { type: 'warning', ...options });
};

export const showInfoToast = (message, options = {}) => {
  showToast(message, { type: 'info', ...options });
};

export default {
  showToast,
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
  initializeToast
};
